module.exports = __webpack_public_path__ + "jobs-2ec46bc8/video-c942510ba422e55ebbc79788086e1b55.svg";